import { useMemo } from 'react';
import { sortBy } from 'lodash';

import { useMyAccount, useMyStore, useQuery } from '../hooks';

import { DTCC_PROMOTION_PLANS } from '../../graphql/dtcc-queries';

import { CarCareOnePromotionData, Maybe } from '../../types/graphql-types';
import { AEM_CONTENT_IDS } from '../../constants/cms';

export default function useDTCCFinancingPromotion(value) {
  const { myStore } = useMyStore();
  const { isFleetAccount } = useMyAccount();

  const { code: storeCode } = myStore || {};

  const valueAsNumber = typeof value === 'number' ? value : NaN;

  const { data: dtccPromoData } = useQuery(DTCC_PROMOTION_PLANS, {
    skip:
      isNaN(valueAsNumber) ||
      (process.env.__FF_FLEET_ACCOUNT__ === 'true' && isFleetAccount),
    variables: {
      storeCode
    }
  });

  const { promotionData, promotionTermsCmsId } = useMemo(() => {
    const promoPlans =
      dtccPromoData?.storeCheckout?.['allCC1PromotionPlans'] || [];

    let promotionTermsCmsId = '';

    const promotionData = sortBy<Maybe<CarCareOnePromotionData>>(
      promoPlans,
      'maxOrderAmount'
    ).find((plan, index) => {
      if (valueAsNumber <= plan?.maxOrderAmount) {
        if (index === 0) {
          promotionTermsCmsId = AEM_CONTENT_IDS.dtccModalTermsOrderTotalRange1;
        } else if (index === 1) {
          promotionTermsCmsId = AEM_CONTENT_IDS.dtccModalTermsOrderTotalRange2;
        } else if (index === 2) {
          promotionTermsCmsId = AEM_CONTENT_IDS.dtccModalTermsOrderTotalRange3;
        } else if (index === 3) {
          promotionTermsCmsId = AEM_CONTENT_IDS.dtccModalTermsOrderTotalRange4;
        }
        return true;
      }
      return false;
    });

    return {
      promotionData,
      promotionTermsCmsId
    };
  }, [dtccPromoData, valueAsNumber]);

  return {
    promotionData,
    promotionTermsCmsId
  };
}
